export default function DS_Regression_Info() {
  return <div>DS_Regression_Info Component</div>;
}
